// Tagalog strings for the field screens owned by fieldA: Scan home, Asset quick view, Sync status, offline queue messages,
// Location contents sheet, Guest loaners, scanned-tag landing page. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " (browser storage in use: {size})": " (ginagamit na storage ng browser: {size})",
  " (Overdue {time})": " (Lampas na {time})",
  " A Repair Record was raised for the damaged item.": " Gumawa ng Repair Record para sa sirang item.",
  " A replacement charge of {currency} {amount} was recorded.": " Naitala ang singil sa kapalit na {currency} {amount}.",
  " Ask a storekeeper or the onboarding team to bind it.": " Hilingin sa storekeeper o onboarding team na i-bind ito.",
  " for {property}": " para sa {property}",
  " · from offline data": " · mula sa offline na data",
  "\"{code}\" is not in the data prepared for offline use. Check the code, or try again when you are back online.": "Ang \"{code}\" ay wala sa data na inihanda para sa offline. Suriin ang code, o subukang muli kapag online ka na.",
  "(optional)": "(opsyonal)",
  "({n} available)": "({n} available)",
  ", inactive": ", hindi aktibo",
  "100% in good condition": "100% nasa maayos na kondisyon",
  "A Repair Record (or a replacement charge for an unregistered item) will be raised automatically and the item withdrawn from the fleet.": "Awtomatikong gagawa ng Repair Record (o singil sa kapalit para sa hindi rehistradong item) at aalisin ang item sa fleet.",
  "Across {n} guest room": "Sa {n} kuwarto ng bisita",
  "Across {n} guest rooms": "Sa {n} kuwarto ng bisita",
  "Actions": "Mga aksyon",
  "Actions taken offline wait here and sync in the order they were taken. Prepare for offline before a shift so rooms, count sheets and assets are on this device.": "Ang mga aksyong ginawa offline ay naghihintay dito at isi-sync ayon sa pagkakasunod. Maghanda para sa offline bago ang shift para nasa device na ito ang mga kuwarto, count sheet at asset.",
  "Active": "Aktibo",
  "Active & Recent Guest Loans": "Aktibo at Kamakailang Pahiram sa Bisita",
  "Active On-Loan": "Aktibong Nakapahiram",
  "All Statuses": "Lahat ng Status",
  "Asset": "Asset",
  "Asset quick view": "Asset quick view",
  "Asset quick view saved": "Na-save ang asset quick view",
  "Asset tag or short code": "Asset tag o short code",
  "Audit": "Audit",
  "Audit checklists": "Mga audit checklist",
  "Audit scan": "Audit scan",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipient).": "Naipadala ang awtomatikong paalala sa mga supervisor ng {room} para sa {item} ({n} tatanggap).",
  "Automated reminder notification sent to {room} supervisors for {item} ({n} recipients).": "Naipadala ang awtomatikong paalala sa mga supervisor ng {room} para sa {item} ({n} tatanggap).",
  "Bind this tag to an asset": "I-bind ang tag na ito sa isang asset",
  "Blind count": "Blind count",
  "Camera preview": "Preview ng camera",
  "Camera unavailable": "Hindi magamit ang camera",
  "Camera unavailable ({msg}). Type the code printed under the tag instead.": "Hindi magamit ang camera ({msg}). I-type na lang ang code na nakaprint sa ilalim ng tag.",
  "Cancel": "Kanselahin",
  "Category": "Kategorya",
  "Choose a location": "Pumili ng lokasyon",
  "Choose a location to see what should be in it.": "Pumili ng lokasyon para makita kung ano ang dapat nandoon.",
  "Choose a room, floor, wing or building…": "Pumili ng kuwarto, palapag, wing o gusali…",
  "Choose where the asset is going.": "Piliin kung saan pupunta ang asset.",
  "Close": "Isara",
  "Completed": "Tapos na",
  "Condition": "Kondisyon",
  "Condition now": "Kondisyon ngayon",
  "Condition on return": "Kondisyon sa pagbalik",
  "Condition Rating *": "Rating ng Kondisyon *",
  "Condition: {condition}": "Kondisyon: {condition}",
  "Confirm Issue & Dispatch": "Kumpirmahin ang Pag-issue at Pagpapadala",
  "Confirm Return": "Kumpirmahin ang Pagbalik",
  "Confirm return of": "Kumpirmahin ang pagbalik ng",
  "Conflict": "Conflict",
  "Conflicts": "Mga conflict",
  "Connection": "Koneksyon",
  "Could not read the selected photo": "Hindi mabasa ang napiling larawan",
  "Count sheets": "Mga count sheet",
  "Counted": "Nabilang",
  "Custodian": "Tagapag-ingat",
  "Custody return": "Pagbalik ng custody",
  "Damage report": "Ulat ng sira",
  "Damage reported ({ref}) with a photo.": "Naiulat ang sira ({ref}) kasama ang larawan.",
  "Damage reported for {tag} ({ref}).": "Naiulat ang sira para sa {tag} ({ref}).",
  "Damage reported for {tag}.": "Naiulat ang sira para sa {tag}.",
  "Damage reported with a photo.": "Naiulat ang sira kasama ang larawan.",
  "Damaged": "Sira",
  "Describe any damage": "Ilarawan ang anumang sira",
  "Describe the damage (at least 5 characters).": "Ilarawan ang sira (hindi bababa sa 5 character).",
  "Discard": "Itapon",
  "Dismiss": "Isara",
  "Disposed": "Itinapon",
  "Download progress": "Progreso ng pag-download",
  "Downloading": "Nagda-download",
  "Downloading the property and its locations": "Dina-download ang property at mga lokasyon nito",
  "Downloading…": "Nagda-download…",
  "Downloads your open and assigned audits with the expected contents of up to 300 rooms, the count sheets of your property's stock points, first-walk rooms and the quick-view details of every asset, so a full shift works without a connection.": "Dina-download ang iyong bukas at nakatalagang audit kasama ang inaasahang laman ng hanggang 300 kuwarto, ang count sheet ng mga stock point ng property mo, mga first-walk na kuwarto at quick-view ng bawat asset, para gumana ang buong shift kahit walang koneksyon.",
  "e.g. John Doe": "hal. Juan dela Cruz",
  "e.g. RM-201 or AOS7K9": "hal. RM-201 o AOS7K9",
  "e.g. Room 402": "hal. Kuwarto 402",
  "Engineering": "Engineering",
  "Excellent": "Napakahusay",
  "Expected Return": "Inaasahang Pagbalik",
  "Expected Return Window *": "Inaasahang Oras ng Pagbalik *",
  "Export CSV": "I-export ang CSV",
  "Export XLSX": "I-export ang XLSX",
  "Exporting…": "Ini-export…",
  "Fair": "Katamtaman",
  "Field app": "Field app",
  "Filter by status": "I-filter ayon sa status",
  "Find an asset": "Maghanap ng asset",
  "First-walk exception": "Exception sa first walk",
  "First-walk rooms": "Mga kuwarto sa first walk",
  "Food & Beverage": "Food & Beverage",
  "Found in another room": "Nakita sa ibang kuwarto",
  "from": "mula sa",
  "Front Office": "Front Office",
  "Give a reason for the move (at least 3 characters).": "Magbigay ng dahilan ng paglipat (hindi bababa sa 3 character).",
  "Good": "Maayos",
  "Guest loaner issued successfully! {item} ({tag}) is out with {room}; return reminder scheduled for {when}.": "Matagumpay na naibigay ang loaner! Ang {item} ({tag}) ay nasa {room}; nakatakda ang paalala sa pagbalik sa {when}.",
  "Guest Loaners & Overdue Tracker": "Guest Loaner at Overdue Tracker",
  "Guest Name": "Pangalan ng Bisita",
  "Guest Room Number *": "Numero ng Kuwarto ng Bisita *",
  "Guest room number is required": "Kailangan ang numero ng kuwarto ng bisita",
  "Guest Services": "Guest Services",
  "has been printed but is not attached to an asset, location or Stock Point yet.": "ay na-print na pero hindi pa nakakabit sa asset, lokasyon o Stock Point.",
  "Housekeeping": "Housekeeping",
  "How urgent?": "Gaano kaapurahan?",
  "In repair": "Inaayos",
  "In service": "Ginagamit",
  "In store": "Nasa store",
  "In transit": "Nasa biyahe",
  "Inactive": "Hindi aktibo",
  "Issue Guest Loaner Item": "Mag-issue ng Loaner Item sa Bisita",
  "Issue Loaner Item": "Mag-issue ng Loaner Item",
  "Issued": "Naibigay",
  "IT & Telecom": "IT & Telecom",
  "Item": "Item",
  "Kit:": "Kit:",
  "Last audit": "Huling audit",
  "Last sync: {when}": "Huling sync: {when}",
  "Last try: {error}": "Huling subok: {error}",
  "Loading contents…": "Nilo-load ang laman…",
  "Loading guest loans...": "Nilo-load ang mga pahiram sa bisita...",
  "Loading property…": "Nilo-load ang property…",
  "Loan Fleet Availability": "Availability ng Loaner Fleet",
  "Loaned At": "Oras ng Pahiram",
  "Loaner Item": "Loaner Item",
  "Location": "Lokasyon",
  "Location Contents Sheet": "Sheet ng Laman ng Lokasyon",
  "Locations saved": "Na-save ang mga lokasyon",
  "Look up": "Hanapin",
  "Looking up the tag…": "Hinahanap ang tag…",
  "Low (minor / scheduled)": "Mababa (maliit / naka-iskedyul)",
  "Missing": "Nawawala",
  "More than one asset matches": "Higit sa isang asset ang tugma",
  "Move": "Ilipat",
  "Move of {tag} to {place} recorded and sent for approval.": "Naitala ang paglipat ng {tag} sa {place} at ipinadala para sa pag-apruba.",
  "Move of {tag} to {place} recorded.": "Naitala ang paglipat ng {tag} sa {place}.",
  "Needs your attention": "Kailangan ng atensyon mo",
  "Never": "Hindi pa",
  "New": "Bago",
  "Next": "Susunod",
  "No conflicts. If the server refuses a synced action (for example the item was moved, the audit was completed or the count was already submitted), it appears here for you to retry, discard or open.": "Walang conflict. Kung tanggihan ng server ang na-sync na aksyon (hal. nailipat ang item, tapos na ang audit o naisumite na ang bilang), lalabas ito dito para subukang muli, itapon o buksan.",
  "No guest loans found.": "Walang nahanap na pahiram sa bisita.",
  "No loaner items registered": "Walang nakarehistrong loaner item",
  "No locations are available offline. Prepare for offline on the Sync status page first.": "Walang lokasyong available offline. Maghanda muna para sa offline sa Sync status page.",
  "No pooled stock is held here.": "Walang pooled stock dito.",
  "No returns yet today": "Wala pang naibalik ngayong araw",
  "No tagged assets here. Stamp a kit to create the room's expected contents.": "Walang naka-tag na asset dito. Mag-stamp ng kit para gawin ang inaasahang laman ng kuwarto.",
  "No {item} is currently available": "Walang available na {item} sa ngayon",
  "Normal": "Normal",
  "Not accepted": "Hindi tinanggap",
  "Not assigned": "Hindi nakatalaga",
  "Not audited yet": "Hindi pa na-audit",
  "Notes": "Mga tala",
  "Nothing has been prepared on this device yet.": "Wala pang naihanda sa device na ito.",
  "Nothing is waiting. Scans, counts, bindings and moves you make offline are kept here until they reach the server.": "Walang naghihintay. Ang mga scan, bilang, binding at paglipat na ginawa mo offline ay itinatago dito hanggang makarating sa server.",
  "Nothing overdue": "Walang lampas sa takdang oras",
  "Nudge guests from the list below": "Paalalahanan ang mga bisita mula sa listahan sa ibaba",
  "Nudge Room": "Paalalahanan ang Kuwarto",
  "Offline": "Offline",
  "Offline - syncs automatically when back online": "Offline - awtomatikong magsi-sync pag online na",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online (photos need a connection, so it is sent without one).": "Offline: naka-save sa device na ito ang ulat ng sira para sa {tag} at ipapadala pag online ka na (kailangan ng koneksyon ang larawan, kaya ipapadala ito nang wala nito).",
  "Offline: the damage report for {tag} is saved on this device and sent when you are back online.": "Offline: naka-save sa device na ito ang ulat ng sira para sa {tag} at ipapadala pag online ka na.",
  "Offline: the move of {tag} is saved on this device and recorded when you are back online.": "Offline: naka-save sa device na ito ang paglipat ng {tag} at itatala pag online ka na.",
  "Offline: the new condition of {tag} is saved on this device and recorded when you are back online.": "Offline: naka-save sa device na ito ang bagong kondisyon ng {tag} at itatala pag online ka na.",
  "Offline: the return of {tag} is saved on this device and recorded when you are back online.": "Offline: naka-save sa device na ito ang pagbalik ng {tag} at itatala pag online ka na.",
  "On hand": "Nasa kamay",
  "Online": "Online",
  "Open": "Buksan",
  "Open record": "Buksan ang record",
  "Open the first scan walk": "Buksan ang first scan walk",
  "Open the full record": "Buksan ang buong record",
  "Open {asset}": "Buksan ang {asset}",
  "Opening the asset, location or Stock Point this label belongs to.": "Binubuksan ang asset, lokasyon o Stock Point ng label na ito.",
  "Or type the code (room code, asset tag or the short code under the barcode)": "O i-type ang code (room code, asset tag o ang short code sa ilalim ng barcode)",
  "Out of service": "Hindi magamit",
  "Overdue": "Lampas na",
  "Overdue Past Deadline": "Lampas sa Takdang Oras",
  "Par": "Par",
  "Pending": "Nakabinbin",
  "Photo": "Larawan",
  "Photos must be JPEG, PNG or WebP images.": "Dapat JPEG, PNG o WebP ang mga larawan.",
  "Photos need a connection; the report is saved without one and sent when you are back online.": "Kailangan ng koneksyon ang larawan; ise-save ang ulat nang wala nito at ipapadala pag online ka na.",
  "Point the camera at a room's door tag to start its audit, or at an asset's tag to see its status and act on it.": "Itutok ang camera sa tag sa pinto ng kuwarto para simulan ang audit nito, o sa tag ng asset para makita ang status at kumilos.",
  "Pooled stock ({n})": "Pooled stock ({n})",
  "Poor (damaged)": "Mahina (sira)",
  "Prepare for offline": "Maghanda para sa offline",
  "Prepared {when}": "Inihanda {when}",
  "Preparing needs a connection.": "Kailangan ng koneksyon para maghanda.",
  "Previous": "Nakaraan",
  "Print": "I-print",
  "Printed {when}": "Na-print {when}",
  "Property": "Property",
  "Quick Return": "Mabilis na Pagbalik",
  "Reason": "Dahilan",
  "Reason for the move": "Dahilan ng paglipat",
  "Receiving department": "Tatanggap na departamento",
  "Recondition": "I-recondition",
  "Record move": "Itala ang paglipat",
  "Record return": "Itala ang pagbalik",
  "Refresh offline data": "I-refresh ang offline na data",
  "Report damage": "Iulat ang sira",
  "Report issue": "Iulat ang problema",
  "Reports": "Mga ulat",
  "Retired": "Retirado",
  "Retry": "Subukang muli",
  "Return": "Ibalik",
  "Return from custody": "Ibalik mula sa custody",
  "Returned": "Naibalik",
  "Returned damaged": "Naibalik na sira",
  "Returned Today": "Naibalik Ngayon",
  "Room #": "Kuwarto #",
  "Room sign-off": "Sign-off ng kuwarto",
  "Save condition": "I-save ang kondisyon",
  "Saved for offline use - details may have changed since.": "Naka-save para sa offline - maaaring nagbago na ang detalye.",
  "Scan": "I-scan",
  "Scan a room or asset tag. A room offers its audit; an asset opens its quick view. Works offline once the shift is prepared.": "I-scan ang tag ng kuwarto o asset. Ang kuwarto ay nag-aalok ng audit; ang asset ay nagbubukas ng quick view. Gumagana offline kapag naihanda na ang shift.",
  "Scan a tag or type the code printed under it.": "I-scan ang tag o i-type ang code na nakaprint sa ilalim nito.",
  "Scan an asset tag from Scan, or type its code below.": "I-scan ang asset tag mula sa Scan, o i-type ang code nito sa ibaba.",
  "Scanned Tag": "Na-scan na Tag",
  "Search loans": "Maghanap ng pahiram",
  "Search room, guest, item...": "Maghanap ng kuwarto, bisita, item...",
  "Select an expected return window": "Pumili ng inaasahang oras ng pagbalik",
  "Select Available Equipment *": "Pumili ng Available na Kagamitan *",
  "Select item...": "Pumili ng item...",
  "Select the equipment to issue": "Piliin ang kagamitang ibibigay",
  "Send damage report": "Ipadala ang ulat ng sira",
  "Serial": "Serial",
  "Starting": "Nagsisimula",
  "Status": "Status",
  "Status, condition and last audit, with the actions you can take here. Actions work offline and sync later.": "Status, kondisyon at huling audit, kasama ang mga aksyong magagawa mo dito. Gumagana offline ang mga aksyon at magsi-sync mamaya.",
  "Stop": "Itigil",
  "Stored on this device: {size}": "Nakatago sa device na ito: {size}",
  "Storekeeper": "Storekeeper",
  "Sync finished: {parts}.": "Tapos ang sync: {parts}.",
  "Sync now": "I-sync ngayon",
  "Sync paused; it resumes automatically": "Naka-pause ang sync; awtomatiko itong magpapatuloy",
  "Sync status": "Sync status",
  "Syncing…": "Nagsi-sync…",
  "Tag": "Tag",
  "Tag binding": "Pag-bind ng tag",
  "Tag not bound yet": "Hindi pa naka-bind ang tag",
  "Tag {code} belongs to a stock point. Open Blind Counts to count it.": "Ang tag {code} ay sa isang stock point. Buksan ang Blind Counts para bilangin ito.",
  "Tag {code} has been retired. Replace the label with a new tag.": "Na-retire na ang tag {code}. Palitan ang label ng bagong tag.",
  "Tag {code} is no longer in use and cannot be bound again. Replace the label with a new tag.": "Hindi na ginagamit ang tag {code} at hindi na maaaring i-bind muli. Palitan ang label ng bagong tag.",
  "Tag {code} is not attached to an asset yet. Bind it during the first scan walk.": "Hindi pa nakakabit sa asset ang tag {code}. I-bind ito sa first scan walk.",
  "Tag: {tag}": "Tag: {tag}",
  "Tagged assets ({n})": "Mga naka-tag na asset ({n})",
  "taken {when}": "ginawa {when}",
  "That tag is not attached to an asset.": "Hindi nakakabit sa asset ang tag na iyan.",
  "The action was not accepted": "Hindi tinanggap ang aksyon",
  "the asset it was on": "ang asset na kinabitan nito",
  "The download needs a connection. Try again when you are online.": "Kailangan ng koneksyon sa pag-download. Subukang muli pag online ka na.",
  "The label may belong to another property, or the code was read incorrectly. Try typing the short code printed under the barcode.": "Maaaring sa ibang property ang label, o mali ang pagbasa sa code. Subukang i-type ang short code sa ilalim ng barcode.",
  "the new location": "ang bagong lokasyon",
  "The record changed while you were offline": "Nagbago ang record habang offline ka",
  "The tag could not be looked up": "Hindi mahanap ang tag",
  "This asset was not found, or it belongs to a property you cannot see.": "Hindi nahanap ang asset na ito, o nasa property itong hindi mo nakikita.",
  "This browser cannot read tags with the camera. Type the code printed under the tag, or use a handheld scanner into the field below.": "Hindi kayang basahin ng browser na ito ang tag gamit ang camera. I-type ang code sa ilalim ng tag, o gumamit ng handheld scanner sa field sa ibaba.",
  "This property has no locations yet": "Wala pang lokasyon ang property na ito",
  "This tag has been retired": "Na-retire na ang tag na ito",
  "To location": "Papunta sa lokasyon",
  "Track loaner items issued to guest rooms and follow up on overdue returns.": "Subaybayan ang mga loaner item na naibigay sa kuwarto ng bisita at follow-up sa mga lampas na pagbalik.",
  "Urgent (guest-facing / safety)": "Apurahan (nakaharap sa bisita / kaligtasan)",
  "Verified": "Na-verify",
  "Waiting": "Naghihintay",
  "Waiting to sync": "Naghihintay ma-sync",
  "We could not find this tag": "Hindi namin mahanap ang tag na ito",
  "What is in a room right now: tagged assets one by one and pooled stock against par. Pick a floor or wing to print one sheet per room.": "Ano ang nasa kuwarto ngayon: naka-tag na asset isa-isa at pooled stock laban sa par. Pumili ng palapag o wing para mag-print ng isang sheet bawat kuwarto.",
  "What is wrong?": "Ano ang problema?",
  "Will retry": "Susubukang muli",
  "Written off": "Na-write off",
  "You are offline and nothing has been prepared for offline use yet. Open Sync status and choose Prepare for offline before your next shift.": "Offline ka at wala pang naihanda para sa offline. Buksan ang Sync status at piliin ang Maghanda para sa offline bago ang susunod mong shift.",
  "You are offline. Actions stay on this device and sync automatically when the connection returns.": "Offline ka. Mananatili sa device na ito ang mga aksyon at awtomatikong magsi-sync pagbalik ng koneksyon.",
  "Your role can view this asset but has no actions on it.": "Makikita ng role mo ang asset na ito pero walang aksyon dito.",
  "Your role has no field actions for a room. Scan an asset tag to see the asset.": "Walang field action ang role mo para sa kuwarto. I-scan ang asset tag para makita ang asset.",
  "Your session has expired. Sign in again to sync; nothing on this device is lost.": "Nag-expire na ang session mo. Mag-sign in muli para mag-sync; walang mawawala sa device na ito.",
  "{checklists} room checklists ({rooms} rooms, {batches} open audit)": "{checklists} checklist ng kuwarto ({rooms} kuwarto, {batches} bukas na audit)",
  "{checklists} room checklists ({rooms} rooms, {batches} open audits)": "{checklists} checklist ng kuwarto ({rooms} kuwarto, {batches} bukas na audit)",
  "{code} is a room, not an asset. Open it from Scan.": "Ang {code} ay kuwarto, hindi asset. Buksan ito mula sa Scan.",
  "{item} marked as Returned ({condition}) and restored to active housekeeping inventory.": "Ang {item} ay minarkahang Naibalik ({condition}) at ibinalik sa aktibong imbentaryo ng housekeeping.",
  "{item} marked as Returned ({condition}) and withdrawn from the loaner fleet.": "Ang {item} ay minarkahang Naibalik ({condition}) at inalis sa loaner fleet.",
  "{n} assets for quick view": "{n} asset para sa quick view",
  "{n} conflict": "{n} conflict",
  "{n} conflicts": "{n} conflict",
  "{n} count sheets": "{n} count sheet",
  "{n} first-walk rooms": "{n} kuwarto sa first walk",
  "{n} Item": "{n} Item",
  "{n} Items": "{n} Item",
  "{n} items could not be downloaded": "{n} item ang hindi na-download",
  "{n} loans": "{n} pahiram",
  "{n} locations": "{n} lokasyon",
  "{n} not accepted": "{n} hindi tinanggap",
  "{n} returned damaged": "{n} naibalik na sira",
  "{n} synced": "{n} na-sync",
  "{pct}% in housekeeping store": "{pct}% nasa housekeeping store",
  "{tag} is now graded {grade}.": "Ang {tag} ay naka-grade na ngayon bilang {grade}.",
  "{tag} returned in {condition} condition.": "Naibalik ang {tag} sa kondisyong {condition}.",
  "· {n} need attention": "· {n} kailangang asikasuhin",
  "· {n} waiting to sync": "· {n} naghihintay ma-sync",
};
